import { apiService } from '../api/api-client';
import type { BulkMarkRequest, BulkMarkResponse } from '@/types';

/** POST /positions/bulk_mark/ — atomic bulk MTM (Phase 1 endpoint). All-or-nothing on validation failure. */
export const bulkMarkService = {
  async bulkMark(request: BulkMarkRequest): Promise<BulkMarkResponse> {
    return apiService.post<BulkMarkResponse>('/positions/bulk_mark/', request);
  },
};
